<app-modal [title]="(weekExists() ? 'Edit' : 'Add') + ' Maximum Working Hours'" #modalComponent>
  <form (ngSubmit)="onSubmit()" #f="ngForm" class="p-3" autocomplete="off">

    <div class="mb-3 row">
      <label for="minHours" class="col-sm-4 col-form-label">Min Hours</label>
      <div class="col-sm-8">
        <input type="text" readonly class="form-control-plaintext" id="minHours" [value]="minHours() + ' hr p/w'">
      </div>
    </div>

    <div class="mb-3 row">
      <label for="maxHours" class="col-sm-4 col-form-label">Max Hours</label>
      <div class="col-sm-4">
        <select class="form-control" id="maxHours" name="maxHours" [ngModel]="maxHours()"
                (ngModelChange)="maxHours.set($event)">
          @for (hours of hoursOptions(); track hours) {
            <option [ngValue]="hours">{{ hours }}</option>
          }
        </select>
      </div>
      <span class="col-sm-4 mt-2">hr p/w</span>
    </div>

    <div class="mb-3 row">
      <label for="startDate" class="col-sm-4 col-form-label">Start date</label>
      <div class="col-sm-8" id="startDate">
        <app-input-date
                [isDisabled]="weekExists()"
                [name]="'startDate'"
                [inputDate]="startDate()"
                (inputDateChange)="startDate.set($event)"
                [editDate]="editDate"
                [onlyMondays]="true">
        </app-input-date>
      </div>
    </div>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!f.valid || !startDate() || loading()">Save
      </button>
    </div>
  </form>
</app-modal>